<template>
  <div id="app">
    <div class="view-login">
      <com-left-side :origin="origin" class="pc-logo"></com-left-side>
      <div class="main">
        <div class="mobile-logo">
          <svg width="135" height="45" viewBox="0 0 135 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M118.638 1.68262L121.171 1.76442C124.532 5.3787 129.061 7.88845 134.157 8.68995C134.236 8.71594 134.316 8.74185 134.395 8.76769L134.394 11.1478C132.056 10.7892 128.77 10.2548 127.001 9.36887V10.2513H113.002V9.33723C111.074 10.2864 107.881 10.8208 105.638 11.1478L105.639 8.68004C110.748 7.86178 115.284 5.32598 118.638 1.68262ZM115.498 7.97668C117.552 6.77434 119.037 5.60363 120.017 4.46457C120.997 5.63527 122.482 6.80598 124.473 7.97668H115.498ZM129.782 11.9001H110.252V18.7978H126.27C128.21 18.7978 129.782 17.2238 129.782 15.2822V11.9001ZM126.685 14.4771C126.685 15.4479 125.899 16.2349 124.929 16.2349H113.349V14.4314H126.685V14.4771ZM109.083 27.2458H105.955V29.9353H133.984V27.2458H130.856V20.3798H109.083V27.2458ZM115.372 27.2458H112.243V22.7177H115.372V27.2458ZM118.437 22.7177H121.534V27.2458H118.437V22.7177ZM124.599 22.7177H127.791V27.2458H124.599V22.7177ZM51.5628 30.6384L50.5808 27.9243L54.0884 27.7661C55.7317 27.7345 56.0793 27.2282 56.0793 25.5829V2.05637L60.24 2.21457V26.7536C60.24 29.1861 59.6955 30.1747 58.1157 30.6384H51.5628ZM103.434 30.6384C103.168 29.0389 101.796 27.2141 100.57 25.8081H96.4954C98.0099 27.7257 98.9722 29.4049 99.5859 30.6384H103.434ZM95.98 30.6384C95.8544 29.4918 94.6638 27.3817 93.701 25.8081H90.0508C90.1251 25.9556 90.21 26.1184 90.3006 26.2922L90.3008 26.2926C90.6173 26.8998 91.0034 27.6404 91.252 28.3251L92.0709 30.6384H95.98ZM88.1499 30.6384L88.1376 30.5852C87.8253 29.2373 87.3718 27.2804 86.9449 25.8081H83.6656L84.4263 28.3111C84.6117 29.1598 84.7527 29.9418 84.868 30.6384H88.1499ZM78.4969 30.6384C79.7102 28.6463 80.5432 27.0362 81.0134 25.8081H77.5863C76.6765 27.3651 75.3776 29.2871 74.3864 30.6384H78.4969ZM78.4995 24.0501H74.7952V21.1392H87.1053V19.3357H76.786V16.3298H87.1053V14.6529H76.9896V2.8509H101.052V11.1372C101.052 13.0789 99.4797 14.6529 97.5406 14.6529H91.0624V16.3298H101.255V19.3357H91.0624V21.1392H103.246V24.0501H98.9591H78.8155L78.8157 24.0502L78.4995 24.0501ZM98.9591 24.0501L98.9592 24.0502H98.9588L98.9591 24.0501ZM87.1053 11.647V5.37863H80.2129V11.647H87.1053ZM97.8285 5.37863H91.0624V11.647H96.0729C97.0425 11.647 97.8285 10.86 97.8285 9.88918V5.37863ZM67.8641 8.9207L67.8941 9.05921C68.6398 12.4996 69.3287 15.0207 69.9598 16.6294C70.5381 18.1034 71.5743 20.1024 73.0733 22.6299L73.6528 23.5984H69.6931L69.6406 23.524C67.698 20.7693 66.371 18.4396 65.668 16.5376C65.0465 14.8565 64.4265 12.7197 63.8074 10.1289L63.8072 10.1281L63.525 8.9207H67.8641ZM52.0867 8.9207L52.0375 9.13574C51.3412 12.1784 50.6439 14.6466 49.9448 16.5376C49.2418 18.4396 47.9148 20.7693 45.9721 23.524L45.9197 23.5984H41.9586L42.1195 23.3318C43.846 20.4705 45.022 18.2377 45.653 16.6294C46.2841 15.0207 46.973 12.4996 47.7187 9.05921L47.7487 8.9207H52.0867ZM83.2111 5.97624H83.2087H83.2061H83.2035C82.4853 5.97628 81.8315 5.97632 81.4195 5.9762C81.8583 8.87676 83.5262 11.0739 83.5262 11.0739H86.1595C86.1595 11.0739 84.7551 8.08574 84.7551 5.9762C84.2542 5.97618 83.7241 5.97621 83.2243 5.97624H83.2194H83.215H83.2111ZM94.9039 5.97624H94.9015H94.8975H94.8931H94.8882C94.3884 5.97621 93.8584 5.97618 93.3575 5.9762C93.3575 8.08574 91.953 11.0739 91.953 11.0739H94.5864C94.5864 11.0739 96.2542 8.87676 96.6931 5.9762C96.2819 5.97632 95.6299 5.97628 94.9134 5.97624H94.9064H94.9039Z" fill="#14191E"/>
            <path d="M44.2408 35.3113H46.0137V38.8252H49.3684V35.3113H51.1386V44.2125H49.3735V40.3639H46.0188V44.2125H44.2408V35.3113Z" fill="#14191E"/>
            <path d="M61.5756 35.3113H67.0231V36.7957H63.3484V38.8524H66.4605V40.3458H63.3484V42.7203H67.1547V44.2125H61.5756V35.3113Z" fill="#14191E"/>
            <path d="M78.7091 40.9607L76.0369 35.3113H77.9207L78.8046 37.4855C79.0626 38.1509 79.3052 38.7774 79.5787 39.457H79.6265C79.8987 38.7736 80.1568 38.1509 80.4148 37.4855L81.3012 35.3113H83.1489L80.4729 40.9607V44.2125H78.7091V40.9607Z" fill="#14191E"/>
            <path d="M92.4169 35.3113H95.3522C97.1767 35.3113 98.5676 35.8539 98.5676 37.5075C98.5676 38.3291 98.1186 39.1598 97.3586 39.4337V39.4841C98.3147 39.7115 99.0166 40.3884 99.0166 41.5899C99.0166 43.3792 97.5354 44.2086 95.5832 44.2086H92.4169V35.3113ZM95.2284 38.9376C96.3574 38.9376 96.8386 38.4855 96.8386 37.7749C96.8386 36.9998 96.3225 36.6858 95.2464 36.6858H94.1897V38.9376H95.2284ZM95.4271 42.8392C96.6309 42.8392 97.2902 42.4064 97.2902 41.484C97.2902 40.621 96.6451 40.2489 95.4271 40.2489H94.1897V42.8392H95.4271Z" fill="#14191E"/>
            <path d="M108.401 39.7244C108.401 36.8318 110.017 35.1562 112.372 35.1562C114.727 35.1562 116.336 36.8422 116.336 39.7244C116.336 42.6066 114.719 44.3753 112.366 44.3753C110.012 44.3753 108.401 42.6157 108.401 39.7244ZM114.536 39.7244C114.536 37.8253 113.693 36.682 112.372 36.682C111.051 36.682 110.207 37.8253 110.207 39.7244C110.207 41.6235 111.044 42.8392 112.366 42.8392C113.687 42.8392 114.529 41.6235 114.529 39.7244H114.536Z" fill="#14191E"/>
            <path d="M127.504 39.6301L125.156 35.3113H127.128L128.019 37.1548C128.231 37.5695 128.421 38.001 128.682 38.5565H128.73C128.948 38.001 129.131 37.5695 129.325 37.1548L130.166 35.3113H132.035L129.697 39.7102L132.196 44.2125H130.228L129.231 42.241C129.01 41.7824 128.792 41.3225 128.534 40.7747H128.486C128.263 41.3225 128.052 41.7824 127.841 42.241L126.894 44.2125H125.014L127.504 39.6301Z" fill="#14191E"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.7154 3.62349L28.9387 7.79807L35.5201 11.5961C35.9221 11.8298 36.1685 12.2583 36.1685 12.7193V20.7893V32.2158C36.1685 32.6768 35.9221 33.1053 35.5201 33.339L35.4942 33.352L30.1123 36.4618C29.5936 36.7604 28.9452 36.3839 28.9452 35.7866V17.3678C28.9452 16.9068 28.6988 16.4783 28.2968 16.2446L22.6945 13.0049C22.26 12.7582 21.7219 13.0699 21.7219 13.5698V18.0884C21.7219 18.5169 21.3717 18.8675 20.9438 18.8675H15.2507C14.8227 18.8675 14.4726 18.5169 14.4726 18.0884V8.24604V0.779839C14.4726 0.182542 15.121 -0.194014 15.6397 0.104635L21.7154 3.62349ZM14.4467 41.383L7.22333 37.2084L0.648414 33.4104C0.246397 33.1767 0 32.7482 0 32.2872V24.2172V12.7907C0 12.3297 0.246397 11.9012 0.648414 11.6675L0.67435 11.6545L6.05619 8.54469C6.57492 8.24604 7.22333 8.6226 7.22333 9.2199V27.6387C7.22333 28.0997 7.46973 28.5282 7.87174 28.7619L13.474 32.0016C13.9085 32.2483 14.4467 31.9366 14.4467 31.4367V26.918C14.4467 26.4896 14.7968 26.139 15.2248 26.139H20.9178C21.3458 26.139 21.6959 26.4896 21.6959 26.918V36.754V44.2202C21.6959 44.8175 21.0475 45.194 20.5288 44.8954L14.4467 41.383Z" fill="#14191E"/>
          </svg>
        </div>
        <div class="login-container">
          <com-phone-login
            v-if="login_type == 'code'"
            :origin="origin"
            :account="{ value: phoneNumber }"
            @update:phoneNumber="updatePhoneNumber"
            @changeLogin="changeLogin"
            @wechatLogin="wechatLogin"
            @setUserInfo="loginSetUserInfo"
            @googleVertify="toGoogleVertify"
            ref="code-component"
          ></com-phone-login>
          <com-password-login
            v-else-if="login_type == 'pwd'"
            :origin="origin"
            :ph_num="phoneNumber"
            @update:phoneNumber="updatePhoneNumber"
            @changeLogin="changeLogin"
            @wechatLogin="wechatLogin"
            @setUserInfo="loginSetUserInfo"
            @googleVertify="toGoogleVertify"
            ref="pwd-component"
          ></com-password-login>
          <com-qr-login
            v-else-if="login_type == 'qr'"
            @changeLogin="changeLogin"
            @wechatLogin="wechatLogin"
            @setUserInfo="loginSetUserInfo"
            @googleVertify="toGoogleVertify"
            ref="qr-component"
          ></com-qr-login>
          <com-google-vertify
            v-else
            :vertify-info="google_vertify_info"
            @setUserInfo="loginSetUserInfo"
          ></com-google-vertify>
        </div>
        <div class="bottom-company-info">
          清枫（北京）科技有限公司 © 2015 - {{ currentYear }} All rights
          reserved
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper';
import { getPermission, wechatLogin } from '_api/account/login-v2';
import ComLeftSide from './components/com-left-side.vue';
import ComPhoneLogin from './components/com-phone-login.vue';
import ComQrLogin from './components/com-qr-login.vue';
import ComPasswordLogin from './components/com-password-login.vue';
import ComGoogleVertify from './components/com-google-vertify.vue';

// import QRCode from 'qrcode'
// import Qs from 'qs'

export default {
  components: {
    ComLeftSide,
    ComPhoneLogin,
    ComQrLogin,
    ComGoogleVertify,
    ComPasswordLogin
  },
  data() {
    return {
      isWechat: false,
      toast: false,
      isAppLogin: false,
      login_type: 'code',
      origin: '',
      google_vertify_info: {},
      phoneNumber: '',
    };
  },
  created() {
    this.origin = this.$utils.getUrlParam('origin');
    if (this.$utils.getUrlParam('src')) {
      // 微信登录成功重定向
      this.isWechat = true;
      this.wechatGetUserInfo();
    }
  },
  methods: {
    updatePhoneNumber(newValue) {
      this.phoneNumber = newValue; // 更新电话号码
    },
    toGoogleVertify(info) {
      this.google_vertify_info = info;
      this.login_type = 'google';
    },
    wechatGetUserInfo() {
      wechatLogin({
        web_source: 'open',
        _notip: true,
        heybox_id: '',
      }).then((res) => {
        if (res.data.status === 'ok') {
          this.loginSetUserInfo(res);
        } else if (res.data.status == 'need_google_check') {
          this.toGoogleVertify(res.data.result);
        }
      });
    },
    wechatLogin() {
      let redirect_url = location.href;
      if (redirect_url.indexOf('?') > 0) {
        redirect_url += '&src=1';
      } else {
        redirect_url += '?src=1';
      }
      window.location = `https://api.xiaoheihe.cn/account/wechat/login/v2/web_sso/?redirect_url=${encodeURIComponent(redirect_url)}`;
    },
    changeLogin(type) {
      if (type == 'qr') {
        this.login_type = 'qr';
        this.$nextTick(() => {
          this.$refs['qr-component'].getLoginQrCode();
        });
      } else {
        this.login_type = type;
      }
    },
    loginSetUserInfo(res) {
      this.warning = '';
      const date = 'd7';
      const r = res.data.result;
      const heyboxId = r.account_detail.userid;
      this.setCookie('heybox_id', heyboxId, date);
      const nickname = r.account_detail.username;
      this.setCookie('nickname', nickname, date);
      const avatar = r.account_detail.avartar;
      this.setCookie('avatar', avatar, date);
      const level = r.account_detail.level_info.level;
      this.setCookie('level', level, date);
      if (r.pkey) {
        const pkey = r.pkey;
        this.setCookie('pkey', pkey, date);
      }
      // 百科权限管理
      const wikiAdmin = r.wiki_admin;
      this.setCookie('wa', wikiAdmin, date);
      const wikiRoot = r.wiki_root;
      this.setCookie('wr', wikiRoot, date);
      const wikiSenior = JSON.stringify(r.wiki_senior);
      this.setCookie('ws', wikiSenior, date);
      const wikiJunior = JSON.stringify(r.wiki_junior);
      this.setCookie('wj', wikiJunior, date);
      const wikiCivilian = JSON.stringify(r.wiki_civilian);
      this.setCookie('wc', wikiCivilian, date);

      const wikiPower = r.wiki_admin || r.wiki_root;
      this.setCookie('wiki_power', wikiPower, date);
      getPermission()
        .then(({ data }) => {
          if (data) {
            let permission = data.bbs_super_permission;
            this.setCookie('permission', permission, date);
            this.setCookie('ac', data.allow_contribution, date);
            // 开放平台bbs权限
            const bbsRoot = data.topic_permissions.root;
            this.setCookie('br', bbsRoot, date);
            const bbsEditorSuper = JSON.stringify(
              data.topic_permissions.editor.super,
            );
            this.setCookie('bes', bbsEditorSuper, date);
            const bbsEditorAdvanced = JSON.stringify(
              data.topic_permissions.editor.advanced,
            );
            this.setCookie('bea', bbsEditorAdvanced, date);
            const bbsEditorBasic = JSON.stringify(
              data.topic_permissions.editor.basic,
            );
            this.setCookie('beb', bbsEditorBasic, date);
            const bbsModeratorSuper = JSON.stringify(
              data.topic_permissions.moderator.super,
            );
            this.setCookie('bms', bbsModeratorSuper, date);
            const bbsModeratorAdvanced = JSON.stringify(
              data.topic_permissions.moderator.advanced,
            );
            this.setCookie('bma', bbsModeratorAdvanced, date);
            const bbsModeratorBasic = JSON.stringify(
              data.topic_permissions.moderator.basic,
            );
            this.setCookie('bmb', bbsModeratorBasic, date);
            // 反馈系统客服权限
            const feedbackStaffSuper = JSON.stringify(
              data.topic_permissions.customer_service.super,
            );
            this.setCookie('fss', feedbackStaffSuper, date);
            const feedbackStaffAdvanced = JSON.stringify(
              data.topic_permissions.customer_service.advanced,
            );
            this.setCookie('fsa', feedbackStaffAdvanced, date);
            const feedbackStaffBasic = JSON.stringify(
              data.topic_permissions.customer_service.basic,
            );
            this.setCookie('fsb', feedbackStaffBasic, date);
          }
        })
        .then((res) => {
          // 登录成功之后跳转
          if (this.isWechat) {
            this.isWechat = false;
          }
          let redirect_url = decodeURIComponent(
            this.$utils.getUrlParam('redirect_url'),
          );
          if (redirect_url) {
            window.location.href = redirect_url;
          } else {
            window.location.href = 'https://www.xiaoheihe.cn/';
          }
        });
    },
    setCookie(name, value, time) {
      const domain =
        window.location.host === 'login.debugmode.cn'
          ? 'debugmode.cn'
          : 'xiaoheihe.cn';
      var strSec = getSec(time);
      var exp = new Date();
      exp.setTime(exp.getTime() + strSec * 1);
      document.cookie = `${name}=${escape(value)};expires=${exp.toGMTString()};path=/;domain=${domain}`;
      // document.cookie = `${name}=${escape(value)};expires=${exp.toGMTString()};path=/`
      function getSec(str) {
        var str1 = str.substring(1, str.length) * 1;
        var str2 = str.substring(0, 1);
        if (str2 === 's') {
          return str1 * 1000;
        } else if (str2 === 'h') {
          return str1 * 60 * 60 * 1000;
        } else if (str2 === 'd') {
          return str1 * 24 * 60 * 60 * 1000;
        }
      }
    },
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
<style lang="less">
@import '~_style/common.css';

.view-login {
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  .side {
    display: flex;
    flex-direction: column;
    width: 38.2%;
    @media (max-width: 450px) {
        display: none;
    }
    .top {
      position: relative;
      flex: 1;
      background: #1c1c1e
        url('https://imgheybox.max-c.com/oa/2023/02/08/4591b1635700c5aa1bc143d76bd50c4e.svgz')
        center/cover;
      .logo {
        position: absolute;
        top: 40px;
        left: 40px;
        height: 20px;
      }
    }
    .bottom {
      height: calc(50% - 140px);
      background: #18181a;
      color: #ffffff;
      padding: 20px 20px 30px 20px;
      .slider {
        width: 100%;
        height: 100%;
        .slider-item {
          text-align: left;
          color: #e0e0e0;
          .t1 {
            font-size: 20px;
            font-weight: 600;
            line-height: 36px;
            margin-bottom: 8px;
          }
          .t2 {
            font-size: 18px;
            font-weight: 300;
            line-height: 25px;
          }
        }
      }
      .pagination-outer {
        display: flex;
        .pagination {
          height: 4px;
          width: 30px;
          background: #ffffff;
          &.grey {
            opacity: 0.1;
            background-color: #ffffff;
          }
        }
      }
    }
  }
  .main {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 61.8%;
    background: #fff;
    .mobile-logo {
      display: none;
    }
    @media (max-width: 450px) {
      .mobile-logo {
        width: 300px;
        display: block;
        position: relative;
        top: 107px;
        left: calc(50vw - 150px);
      }
    }
    .login-container {
      width: 390px;
      margin: auto;
      @media (max-width: 450px) {
        width: 100vw;
      }
      .code-login-wrapper {
        width: 100%;
        height: 192px;
        display: flex;
        align-items: flex-end;
        margin-top: 20px;
        .right-box {
          width: 184px;
          height: 184px;
          margin-left: 26px;
          .qr-code-wrapper {
            width: 100%;
            height: 100%;
          }
          .fail-box,
          .success-box {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .qrcode-box {
              width: 100%;
              height: 100%;
              #login-qrcode {
                width: 100%;
                height: 100%;
              }
            }
            .icon {
              width: 40px;
              height: 40px;
              margin-bottom: 16px;
              color: #fff;
              border-radius: 50%;
              .iconfont {
                width: 40px;
                height: 40px;
                font-size: 24px;
                &:before {
                  line-height: 40px;
                }
              }
            }
            .title {
              line-height: 16px;
              font-size: 16px;
              color: #14191e;
              font-weight: 600;
            }
            .refresh,
            .desc {
              line-height: 12px;
              margin-top: 12px;
              font-size: 12px;
            }
            .refresh {
              cursor: pointer;
              color: #168fd0;
            }
            .desc {
              color: #14191e;
            }
          }
        }
        .left-box {
          width: 180px;
          height: 192px;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }
    }
    .bottom-company-info {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
      color: #c8cdd2;
      font-size: 14px;
      @media (max-width: 450px) {
        display: none;
      }
    }
  }
}
</style>
